var masterSlides = [];
var masterBigSlides = [];  //there are two seperate sliders
var getMasterSlidesAttempts = 0;
var setFirstReviewAttemps = 0;
var subscriptionProduct = '';

$( document ).ready( function() {
  if ( typeof vproducts !== "undefined" ) {
  	subscriptionProduct = findProduct( vproducts, isSubscriptionProduct );
    setupVariants( vproducts, vproduct_id );
  } else {
    $( 'packCont' ).remove();
  }

  getMasterSlides();
  setFirstReview();
} );

function getMasterSlides() {
  getMasterSlidesAttempts++;

  if ($('.product-images__thumbs.flickity-enabled').length > 0) {
    masterSlides = $('.product-images__thumbs.flickity-enabled').flickity('getCellElements');
    masterBigSlides = $('.product-images__slider.flickity-enabled').flickity('getCellElements');
    $("input[name='offer']:checked").click();
    return;
  }

  if (getMasterSlidesAttempts < 30)
    setTimeout(function(){getMasterSlides();},200);
}

function setFirstReview() {
  setFirstReviewAttemps++;

  if ($('span.spr-badge').length > 0) {
    $('span.spr-badge').hide();
    $('span.spr-badge[id=spr_badge_'+product.id+']').show();
    return;
  }

  if (setFirstReviewAttemps < 30)
    setTimeout(function(){setFirstReview();},200);
}
function changeSelectedVariant(product) {
  $('form#AddToCartForm--product-template').attr('data-productid',product.id).find('input[name=id]').attr('data-productid',product.id).attr('value',product.variants[0].id);
  $('form#AddToCartForm--product-template #rc_subscription_id').remove();
  $('form#AddToCartForm--product-template #rc_shipping_interval_unit_type').remove();
  $('form#AddToCartForm--product-template #rc_shipping_interval_frequency').remove();
  $('input#pack').remove();
  $('input#single').remove();
  //$('form#AddToCartForm--product-template')find('#rc_shipping_interval_frequency,#rc_subscription_id,#rc_shipping_interval_unit_type').remove();
  if (subscriptionProduct && subscriptionProduct.variants[0].id == product.variants[0].id) {
    var recharge_pid = metafields[product.id]['recharge_id'].toString();
    $('form#AddToCartForm--product-template').attr('data-productid',recharge_pid).find('input[name=id]').attr('data-productid',recharge_pid); //.attr('value',product.variants[0].id);
    $('form#AddToCartForm--product-template').append('<input type="hidden" name="properties[subscription_id]" id="rc_subscription_id" value="'+metafields[product.id]['subscription_id'].toString()+'">');
    $('form#AddToCartForm--product-template').append('<input type="hidden" name="properties[shipping_interval_unit_type]" id="rc_shipping_interval_unit_type" value="'+metafields[product.id]['shipping_interval_unit_type'].toString()+'">');
    $('form#AddToCartForm--product-template').append('<input type="hidden" name="properties[shipping_interval_frequency]" id="rc_shipping_interval_frequency" value="'+metafields[product.id]['shipping_interval_frequency'].toString()+'">');
  }
  $('div.product-description').html(product.description);
  $('h1.product-title').html(product.title);
  $('div.product-desc-small p').html(metafields[product.id]['size']);
  $('#AddToCartForm--product-template span#ProductPrice').html('$' + (product.price/100.0).toFixed(2));
  $('.extra_product_section.'+product.id.toString()).show();
  var currentSlides = $('.product-images__thumbs.flickity-enabled').flickity('getCellElements');
  $(currentSlides).each(function(){
    $('.product-images__thumbs.flickity-enabled').flickity('remove',this);
  });
  $(masterSlides).each(function(){
    if ($(this).hasClass(product.id))
      $('.product-images__thumbs.flickity-enabled').flickity('append',this);
  });
//masterBigSlides = $('.product-images__slider.flickity-enabled').flickity('getCellElements');
  var currentSlides = $('.product-images__slider.flickity-enabled').flickity('getCellElements');
  $(currentSlides).each(function(){
    $('.product-images__slider.flickity-enabled').flickity('remove',this);
  });
  console.log(product.id);
  $(masterBigSlides).each(function(){
    if ($(this).hasClass(product.id))
      $('.product-images__slider.flickity-enabled').flickity('append',this);
  });

  $('.product-images__thumbs.flickity-enabled').flickity('select',0);
  console.log($('.product-images__slider.flickity-enabled').flickity('getCellElements'));
  $('span.spr-badge').hide();
  $('span.spr-badge[id=spr_badge_'+product.id+']').show();
}

// Setup variants, ties VARIANTS collection products together
function setupVariants( products, product_id ) {

  // find one-time, subscription
  var oneTime = findProduct( products, isOneTimeProduct );
  var subscription = findProduct( products, isSubscriptionProduct );

  // Select One-Time option
  var oneTimeOption = $( '#rechargeOffer' ).parent();
  $( oneTimeOption ).addClass( 'redirectOption' );
  $( oneTimeOption ).find( 'label' ).text( 'ONE-TIME PURCHASE ($' + ( oneTime.variants[0].price / 100).toFixed(2) + ')' );
  $( '.redirectOption' ).on( 'click', function() {
      changeSelectedVariant(oneTime);
    } );

  if (subscriptionProduct) {
  // Create subscribe option, copy one-time option
  var clone = $( oneTimeOption ).clone();
  $( clone ).addClass( 'redirectOption3Pack' ).removeClass( 'redirectOption' );
  $( clone ).find( 'input' ).attr( 'id', 'recharge2ndOption' );
  $( clone ).find( 'label' ).attr( 'for', 'recharge2ndOption' ).text( '3-PACK AUTO SHIP (SAVE 10%) + FREE SHIPPING' );
  $( oneTimeOption ).after( $( clone ) );
  $( '.redirectOption3Pack' ).off( 'click' );
  $( '.redirectOption3Pack' ).on( 'click', function() {
      changeSelectedVariant(subscription);
    } );
  }

  // attempt to set the correct radio option here... (rcWidget may update afterward though...)
  $( '#AddToCartForm--product-template input[type="radio"]' ).prop( 'checked', false );
  //
  setTimeout( function () {
    if ( product.tags.indexOf( 'one-time' ) > -1 ) {
      //$( '#rechargeOffer, .rc_radio.rc_radio__onetime' ).prop( 'checked', true );
    } else if ( product.tags.indexOf( 'subscribe' ) > -1 ) {
      // NOTE: this is now handled on subscription-product.liquid, and the below logic to select the correct option is unneccessary
      // $('#recharge2ndOption, .rc_radio.rc_radio__autodeliver').prop( 'checked', true );
      // $( '#recharge2ndOption, .rc_radio.rc_radio__autodeliver' ).trigger( 'click' );
      $( 'span#rc_price_onetime' ).html( '(' + $( 'span#rc_price_onetime' ).html() + ')' );
      $( 'span#rc_price_autodeliver' ).html( '(' + $( 'span#rc_price_autodeliver' ).html() + ')' );
      $( '.addTocart_div' ).append( $( '#rc_autodeliver_options' ) );
      $( '#rc_autodeliver_options' ).show().css( { 'text-align': 'center' } );
      // attempt to go back to the one-time:
      $( '#rechargeOffer, .rc_radio.rc_radio__onetime' ).on( 'click', function() { changeSelectedVariant(subscription); } );
    } else {
      // $( '#storeOffer' ).prop( 'checked', true );
    }
  }, 500 );

  $('.pdp_variant').click(function(){
  	if (product_id == $(this).data('productid'))
      return;
    document.location.href = $(this).data('target');
  });

    $('.redirectOption input').prop("checked", true);
    $('.redirectOption input').click();
}

// Helper Functions

// Checks if user is logged in. Returns boolean
function isLoggedIn() {
  return typeof customer_id !== 'undefined';
}

// Checks if product is a One-time product. Returns boolen
function isOneTimeProduct( product ) {
  return product.tags.indexOf( 'one-time' ) > -1;
}

// Checks if product is a Subscription product. Returns boolen
function isSubscriptionProduct( product ) {
  return product.tags.indexOf( 'subscribe' ) > -1;
}

// Gets product where `predicate` is true.
// `products` must be array of products (collection.products).
// `predicate` is one-arugment function that returns boolean.
// Returns product, or undefined if not found.
function findProduct( products, predicate ) {
  if ( typeof products === 'undefined' || products.length === 0 ) {
    return;
  }
  return products.find( function ( product ) { return predicate( product ) } );
}
